module.exports = __webpack_public_path__ + "img/example-cafeteria-menu-en.31f7eae8.webp";